<template>
  <div class="form-group form-group--password" :class="getClass()">
    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <label>{{ component.label }}
          <span class="required" v-if="isRequired()">*</span>
        </label>
        <div class="input-group">
          <the-mask class="form-control"
                 :id="component.key"
                 :type="getType()"
                 :name="component.key"
                 :disabled="disabledHandler()"
                 :placeholder="component.placeholder"
                 :maxLength="component.validate.maxLength"
                 v-validate="setRules()"
                 :data-vv-name="component.key"
                 :value="component.data.currentValue"
                 v-model="component.data.currentValue"
                 @focus.native="focusHandler()"
                 @blur.native="blurHandler()"
                 @keyup.13.native="enterHandler()"/>
          <span class="input-group-addon" @click="toggleType()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="18" v-if="!showPass">
              <path class="cls-2" d="M569.354 231.631C512.97 135.949 407.81 72 288 72 168.14 72 63.004 135.994 6.646 231.631a47.999 47.999 0 0 0 0 48.739C63.031 376.051 168.19 440 288 440c119.86 0 224.996-63.994 281.354-159.631a47.997 47.997 0 0 0 0-48.738zM288 392c-102.556 0-192.091-54.701-240-136 44.157-74.933 123.677-127.27 216.162-135.007C273.958 131.078 280 144.83 280 160c0 30.928-25.072 56-56 56s-56-25.072-56-56l.001-.042C157.794 179.043 152 200.844 152 224c0 75.111 60.889 136 136 136s136-60.889 136-136c0-31.031-10.4-59.629-27.895-82.515C451.704 164.638 498.009 205.106 528 256c-47.908 81.299-137.444 136-240 136z"></path>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="18" v-else>
              <path class="cls-2" d="M272.702 359.139c-80.483-9.011-136.212-86.886-116.93-167.042l116.93 167.042zM288 392c-102.556 0-192.092-54.701-240-136 21.755-36.917 52.1-68.342 88.344-91.658l-27.541-39.343C67.001 152.234 31.921 188.741 6.646 231.631a47.999 47.999 0 0 0 0 48.739C63.004 376.006 168.14 440 288 440a332.89 332.89 0 0 0 39.648-2.367l-32.021-45.744A284.16 284.16 0 0 1 288 392zm281.354-111.631c-33.232 56.394-83.421 101.742-143.554 129.492l48.116 68.74c3.801 5.429 2.48 12.912-2.949 16.712L450.23 509.83c-5.429 3.801-12.912 2.48-16.712-2.949L102.084 33.399c-3.801-5.429-2.48-12.912 2.949-16.712L125.77 2.17c5.429-3.801 12.912-2.48 16.712 2.949l55.526 79.325C226.612 76.343 256.808 72 288 72c119.86 0 224.996 63.994 281.354 159.631a48.002 48.002 0 0 1 0 48.738zM528 256c-44.157-74.933-123.677-127.27-216.162-135.007C302.042 131.078 296 144.83 296 160c0 30.928 25.072 56 56 56s56-25.072 56-56l-.001-.042c30.632 57.277 16.739 130.26-36.928 171.719l26.695 38.135C452.626 346.551 498.308 306.386 528 256z"></path>
            </svg>
          </span>
        </div>
        <span class="help-block help-block--bottom" v-if="errors.has(component.key)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">
            <g id="form_icon_error_alert" transform="translate(-252 -635)">
              <rect id="rectangle" class="cls-1" width="14" height="14" transform="translate(252 635)"/>
              <path id="ic_error_outline_24px" class="cls-2" d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z" transform="translate(251 634)"/>
            </g>
          </svg>
          {{ (errors.first(component.key)) }}</span>
        <span class="help-block help-block--bottom" v-if="!errors.has(component.key) && component.description">{{ component.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'
import { TheMask } from '@/directives/mask'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  components: {
    TheMask
  },
  name: 'component-password',
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false,
      showPass: false
    }
  },
  methods: {
    getType () {
      return this.showPass ? 'text' : 'password'
    },
    toggleType () {
      if (!this.disabledHandler()) {
        this.showPass = !this.showPass
      }
    }
  },
  created () {
    this.setValue()
  }
}
</script>
